// extracted by mini-css-extract-plugin
export default {"doc":"DocumentInfo_doc__utbYh"};